module.exports = "https://tutorchat.chegg.com/static/media/ic-pin.431700f3.svg";